import React from "react";
export function BinHintsTable({ binsHints, decimals }) {
    return (React.createElement("table", { className: "listingTable2" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Metoda"),
                React.createElement("th", null, "Po\u010Det t\u0159\u00EDd"),
                React.createElement("th", null, "D\u00E9lka t\u0159\u00EDdy"))),
        React.createElement("tbody", null, binsHints.map(bin => (React.createElement("tr", { key: bin.name },
            React.createElement("td", null, bin.name),
            React.createElement("td", null, bin.m),
            React.createElement("td", null, bin.h.toFixed(decimals))))))));
}
//# sourceMappingURL=BinHintsTable.js.map